import { useState } from "react";
import { useEffect } from "react";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { getAppUpdateByType, postAppUpdate } from "../api/golfClubAPI";


const IOSUpdate = (props) =>{

    const [iOS,                  setIOS]                  = useState({});

    useEffect(() => {
        props.title("iOS Update", "ios-update")
        fetchAppUpdate();
    }, []);
    
    const fetchAppUpdate = async() =>{
        try {
            const app = await getAppUpdateByType('iOS')  
            setIOS(app);             
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }
        
    const updateIOSDetails = (field, value) => {   
        setIOS((d) => {
            return { ...d, [field]: value };
        });
    };
    const updateIOSHandler = async() => {

        const btn = $('#btnUpdate');
        var form = $('#add-iOS-form');
        
        form.validate({
            rules: {
                txtCurrentVersion: {
                    required: true,
                    number: true

                }       
            },
            messages: {
                txtCurrentVersion: {
                    required: "Please enter Version"
                }
            }
        });

        if (!form.valid()) return;
        helper.StartProcessing(btn);

        try {
            await postAppUpdate(iOS);
            helper.StopProcessing(btn);
            fetchAppUpdate();
            swal.fire({
                icon: 'success',
                titleText: 'IOS Version updated!',
                showConfirmButton: false,
                timer: 1500,
            });

        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                      : 'error',
                titleText                 : 'Error!',
                text                      : err.message,
                buttonsStyling            : false,
                confirmButtonclassName    : 'btn btn-brand',
            });
            return;
        }
    }

    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            <form className="kt-form" id="add-iOS-form">
                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Current Version <span className="red">*</span></label>
                                        <div className="col-xl-3 col-lg-4">
                                            <input 
                                                id="txtCurrentVersion" 
                                                name="txtCurrentVersion" 
                                                type="number" 
                                                className="form-control"
                                                value={iOS.CurrentVersion || ''}
                                                onChange={(event) => updateIOSDetails('CurrentVersion', event.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Mandatory</label>
                                        <div className="col-xl-6 col-lg-8">
                                            <span className="kt-switch kt-switch--icon">
                                                <label>
                                                    <input 
                                                        id="chkIsMandatory" 
                                                        name="chkIsMandatory" 
                                                        type="checkbox" 
                                                        checked={iOS.IsMandatory == 'Y' ? 'checked' : ''}
                                                        onChange={(event) => updateIOSDetails('IsMandatory', event.target.checked ? 'Y' : 'N')} 
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <div className="row">
                                    <div className="col-lg-9 ml-lg-auto">
                                        <button id="btnUpdate" type="button" className="btn btn-brand d-inline-block" onClick={updateIOSHandler}>Update</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IOSUpdate;